import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63020102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-recipe-tags" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "container-recipe-tags-selected" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Selected tags:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsContainer = _resolveComponent("TagsContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nSelectedTags) = $event)),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateParent && _ctx.updateParent(...args))),
      multiple: ""
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
        return (_openBlock(), _createElementBlock("option", {
          key: tag.name,
          value: tag
        }, _toDisplayString(tag.name), 9, _hoisted_2))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.nSelectedTags]
    ]),
    (_openBlock(), _createElementBlock("div", { key: _ctx.nSelectedTags }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(), _createBlock(_component_TagsContainer, {
          key: _ctx.nSelectedTags,
          tags: _ctx.nSelectedTags,
          wrap: ""
        }, null, 8, ["tags"]))
      ])
    ]))
  ]))
}